import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { PeoplePickerService } from 'src/app/services/people-picker.service';
import { ProjectService } from 'src/app/services/project.service';
import { SharedServiceService } from 'src/app/services/shared-service.service';
import { UserReplacementService } from 'src/app/services/user-replacement.service';

@Component({
  selector: 'app-project-people-dropdown',
  templateUrl: './project-people-dropdown.component.html',
  styleUrls: ['./project-people-dropdown.component.css']
})
export class ProjectPeopleDropdownComponent implements ICellRendererAngularComp {
  userId: number = 1;
  searchedData: any;
  peoplePicker = new FormControl();
  value: any;
  previousValue: any;
  businessAreaId: number;
  businessLineId: number;
  allUserList: any[] = [];
  activeTargetUserList: any[] = [];

  gridApi: any;
  rowIndex: number;
  projectId: number;
  @Output() userSendData = new EventEmitter<any>();

  constructor(
    private peoplePickerService: PeoplePickerService,
    private sharedService: SharedServiceService,
    private projectService: ProjectService,
    private localStorageService: LocalStorageService,
    private userReplacementSer: UserReplacementService,

  ) { }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  agInit(params: any): void {
    this.rowIndex = params.node.rowIndex;
    this.previousValue = params.data.Email;
    this.gridApi = params.api;
    this.projectId = params.projectId;
    this.businessAreaId = params.businessAreaId;
    this.businessLineId = params.businessLineId;
    this.userReplacementSer.getUserList(this.businessAreaId, this.businessLineId).subscribe((res: any) => {
      if (res) {
        this.allUserList = res;
        // console.log(this.allUserList);
        this.activeTargetUserList = this.allUserList.filter(user => user.IsActive && [1, 2, 3].includes(user.TargetRoleId));
        // console.log(this.activeTargetUserList);
        // this.projectService.getTCData(this.projectId).subscribe((data: any) => {
        //   if (data) {
        //     console.log(data);
        //     const idFields = [
        //       data.Data.FinancialControllerIDs,
        //       data.Data.FinancialControllerProxyIDs,
        //       data.Data.ProcurementEngineerIDs,
        //       data.Data.ProcurementEngineerProxyIDs,
        //       data.Data.ProductManagerIDs,
        //       data.Data.ProductManagerProxyIDs,
        //       data.Data.ProjectManagerIDs,
        //       data.Data.ProjectManagerProxyIDs,
        //       data.Data.ServiceManagerIDs,
        //       data.Data.ServiceManagerProxyIDs,
        //       data.Data.SystemArchitectIDs,
        //       data.Data.SystemArchitectProxyIDs,
        //       data.Data.SubmitterId ? String(data.Data.SubmitterId) : null
        //     ];
        //     console.log(idFields);
        //     // Split each field by ';', flatten, and remove empty strings
        //     const allIds = Array.from(new Set(idFields
        //       .filter(Boolean)
        //       .reduce((acc, ids) => acc.concat(ids.split(';').map(id => Number(id.trim()))), [])
        //       .filter(id => !isNaN(id) && id !== 0)
        //     ));
        //     console.log(allIds);
        //     // Now you can filter your user list:
        //     this.projectTeamList = this.allUserList.filter(user => allIds.includes(user.UserId));
        //     console.log(this.projectTeamList);
        //   }
        // })
      }
    })
  }

  getValue() {
    this.value = this.searchedData;
    if (this.value && this.value != 0) {
      this.gridApi.forEachNode(node => {
        if (this.rowIndex == node.rowIndex) {         
          node.data.OrgCode = this.value[0].department;
        //  node.data.UserName=this.value[0].displayName;
          node.data.UserId= this.value[0].UserId
        }
      })
      this.sharedService.userMangementObj.emit(this.gridApi);
      return this.value[0].displayName
    }
    else {
      return this.previousValue
    }
  }

  getUsers(input) {
    // console.log(input)
    this.peoplePickerService.getUsers(input).subscribe(
      (res: any) => {
        if (res) {
          // this.searchedData = res.value.filter(x => this.activeTargetUserList.some(y => y.Email === x.mail)).map(user => {
          //   return {
          //     // passing a user id;
          //     userId: this.userId,
          //     displayName: user.displayName,
          //     firstName: user.givenName,
          //     lastName: user.surname,
          //     email: user.mail,
          //     department: user.department
          //   }
          // })
          
          this.searchedData = res.value
          .filter(x => this.activeTargetUserList.some(y => y.Email === x.mail))
          .map(x => {
            const matchedUser = this.activeTargetUserList.find(y => y.Email === x.mail);
            return {
              UserId: matchedUser?.UserId || null, // ✅ Add userID from activeTargetUserList
              displayName: x.displayName,
                firstName: x.givenName,
                lastName: x.surname,
                  email: x.mail,
                 department: x.department
                 
            };
          });
        
        }
      }
    );
  }

  userData(data) {
    this.userSendData.emit(data)
  }

}
